var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10390",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.026 11.937a1 1 0 01-1 1l-5.035-.035v5.056a1.024 1.024 0 01-1.739.7 1 1 0 01-.295-.7L11 12.932H6a1 1 0 010-1.991h5V5.92a1 1 0 012 0v4.986l5.035.035a1 1 0 01.991.996z"
  })));
}
export default SvgPlusIcon;